<template>
  <div class="">
    <m-chat-wrapper @rawChatData="rawChatData">
      <template v-slot="{chats,pagination,changePageFunction,un_read_chats}">
        <div class="col-12">
          <table class="table table-striped  ">
            <thead>
            <tr>
              <th scope="col">موضوع</th>
              <th scope="col">وضعیت</th>
              <th scope="col">#</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="chat in chats">
              <th>{{ contentSlicer(chat.subject) }}</th>
              <td>{{ chat.status }}</td>
              <td>
                <i @click="emitSelectedChat(chat)" class="bi bi-box-arrow-left h5"></i>
              </td>
            </tr>
            </tbody>
          </table>
          <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
        </div>
      </template>
    </m-chat-wrapper>
  </div>
</template>


<script>
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import mChatWrapper from "../../Wrappers/ChatWrapper.vue";
import mPaginate1 from "../../Pagination/Paginate1.vue";

export default {
  name: "ChatArchive1",
  components: {mPaginate1, mChatWrapper},
  methods: {
    contentSlicer,
    emitSelectedChat(chat) {
      this.$emit('selectedChat', chat)
    },
    rawChatData(data){
      this.$emit('rawChatData', data)
    }
  },
}
</script>


<style scoped>

</style>